import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/events`;
const token = localStorage.getItem("token");

///GET
// Fonction pour récupérer tous les événements
export const getAllEvents = async () => {
  try {
    const response = await axios.get(`${apiUrl}/allevents`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {}
};

// Fonction pour récupérer les détails d'un événement
export const getEventDetails = async (eventId) => {
  try {
    const response = await axios.get(`${apiUrl}/${eventId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des détails de l'événement:",
      error,
    );
  }
};

/// POST
// Fonction pour créer un événement
export const createEvent = async (formData) => {
  try {
    const response = await axios.post(`${apiUrl}/createevents`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la création de l'événement:", error);
  }
};

// Fonction pour uploader un fichier d'événements (Excel/CSV)
export const uploadEventsFile = async (file) => {
  try {
    const formData = new FormData();
    formData.append("eventsFile", file);

    const response = await axios.post(`${apiUrl}/upload-events`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'upload du fichier d'événements:", error);
  }
};

/// PUT
// Fonction pour mettre à jour un événement
export const updateEvent = async (eventId, formData) => {
  try {
    const response = await axios.put(
      `${apiUrl}/editevents/${eventId}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la modification de l'événement:", error);
  }
};

/// Fonction pour toggle le statut is_active de l'événement
export const toggleEventActive = async (eventId) => {
  try {
    const response = await axios.put(
      `${apiUrl}/activeevents/${eventId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors du changement de l'état de l'événement:", error);
  }
};

/// PATCH
// Fonction pour mettre à jour l'image d'un événement
export const updateEventImage = async (eventId, file, token) => {
  const formData = new FormData();
  formData.append("image", file);
  try {
    const response = await axios.patch(`${apiUrl}/${eventId}/photo`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to update data");
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la mise à jour de l'image de l'article:",
      error,
    );
    return "";
  }
};

/// DELETE
// Fonction pour supprimer un événement
export const deleteEvent = async (eventId) => {
  try {
    const response = await axios.delete(`${apiUrl}/deleteevents/${eventId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression de l'événement:", error);
  }
};

/////////////////////////////////////////////////////////////////////////////////////

/* =========================
   INSCRIPTIONS LICENCIÉS ↔ EVENTS
   ========================= */

const licenciesApiUrl = `${process.env.REACT_APP_API_URL}/api/licencies`;

/**
 * Liste des licenciés inscrits sur un événement
 * GET /api/events/:eventId/registrations
 */
export const getEventRegistrations = async (eventId) => {
  try {
    const { data } = await axios.get(`${apiUrl}/${eventId}/registrations`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data; // Array<{ id, nom, prenom, club, genre, licence_number, saison }>
  } catch (error) {
    console.error(
      "Erreur lors du chargement des inscriptions de l'événement:",
      error,
    );
    throw error;
  }
};

/**
 * Inscrire un licencié à un événement
 * POST /api/events/:eventId/registrations
 * payload possible:
 *  - { licencie_id: number }
 *  - ou { nom, prenom, club, genre: "M"|"F", licence_number, saison: "YYYY-YYYY" }
 */
export const registerLicencieToEvent = async (eventId, payload) => {
  try {
    const { data } = await axios.post(
      `${apiUrl}/${eventId}/registrations`,
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return data; // { ok: true, alreadyRegistered?: true, licencie_id, event_id }
  } catch (error) {
    console.error(
      "Erreur lors de l'inscription du licencié à l'événement:",
      error,
    );
    throw error;
  }
};

/**
 * Désinscrire un licencié d’un événement
 * DELETE /api/events/:eventId/registrations/:licencieId
 */
export const unregisterLicencieFromEvent = async (eventId, licencieId) => {
  try {
    const { data } = await axios.delete(
      `${apiUrl}/${eventId}/registrations/${licencieId}`,
      { headers: { Authorization: `Bearer ${token}` } },
    );
    return data; // { success: true }
  } catch (error) {
    console.error("Erreur lors de la désinscription du licencié:", error);
    throw error;
  }
};

/**
 * Liste des événements auxquels un licencié est inscrit
 * GET /api/licencies/:licencieId/events
 */
export const getEventsForLicencie = async (licencieId) => {
  try {
    const { data } = await axios.get(
      `${licenciesApiUrl}/${licencieId}/events`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return data; // Array<Event>
  } catch (error) {
    console.error(
      "Erreur lors du chargement des événements du licencié:",
      error,
    );
    throw error;
  }
};
